// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Vljnb","title":"styles_title__-rOop","paragraph":"styles_paragraph__MNsni"};